import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    pjeMargenMinimo: 0,
    pjeMargenMaximo: 0,
    premios: false,
    reembolsos: false,
    excluidoComisiones: false,
    requiereValidacionBrief: false,
    descripcion: '',
    plantillaArticulos: '',
    inactivo: false,
    parametrosGlobales: true,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    rowVersion: null,
    
    rubroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_RUBRO'(state, rubroId) {
        state.id = rubroId;
        state.nombre = '';
        state.pjeMargenMinimo = 0;
        state.pjeMargenMaximo = 0;
        state.premios = false;
        state.reembolsos = false;
        state.excluidoComisiones = false;
        state.requiereValidacionBrief = false;
        state.descripcion = '';
        state.plantillaArticulos = '';
        state.inactivo = false;
        state.parametrosGlobales = true;
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.rowVersion = null;
    },
    'SET_RUBRO'(state, rubro) {
        state.nombre = rubro.nombre.toUpperCase().trim();
        state.pjeMargenMinimo = parseFloat(rubro.pjeMargenMinimo);
        state.pjeMargenMaximo = parseFloat(rubro.pjeMargenMaximo);
        state.premios = (/true/i).test(rubro.premios);
        state.reembolsos = (/true/i).test(rubro.reembolsos);
        state.excluidoComisiones = (/true/i).test(rubro.excluidoComisiones);
        state.requiereValidacionBrief = (/true/i).test(rubro.requiereValidacionBrief);
        state.descripcion = rubro.descripcion.trim();
        state.plantillaArticulos = rubro.plantillaArticulos.trim();
        state.inactivo = (/true/i).test(rubro.inactivo);
        state.parametrosGlobales = rubro.parametrosGlobales;
        state.pjeGastosFijos = parseFloat(rubro.pjeGastosFijos);
        state.pjeInversionFutura = parseFloat(rubro.pjeInversionFutura);
        state.pjeImpuestosInternos = parseFloat(rubro.pjeImpuestosInternos);
        state.rowVersion = rubro.rowVersion;
    },

    'INICIALIZAR_RUBRO_DATOS'(state) {
        state.rubroDatos = [];
    },
    'SET_RUBRO_DATOS'(state, rubroDatos) {
        state.rubroDatos = rubroDatos;
    },
};

const getters = {
    getField,

    pjeMargenMinimo (state) {
        return state.pjeMargenMinimo;
    },
    pjeMargenMaximo (state) {
        return state.pjeMargenMaximo;
    },
};

const actions = {
    inicializar ( { commit }, rubroTrabajoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RUBRO', rubroTrabajoId);

            if (rubroTrabajoId != 0) {
                apiAxios.get('rubrostrabajos/' + rubroTrabajoId + '/abm' ) 
                    .then(res => {
                        commit('SET_RUBRO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let rubroTrabajo= {
                nombre: state.nombre.toUpperCase().trim(),
                pjeMargenMinimo: parseFloat(state.pjeMargenMinimo),
                pjeMargenMaximo: parseFloat(state.pjeMargenMaximo),
                premios: (/true/i).test(state.premios),
                reembolsos: (/true/i).test(state.reembolsos),
                excluidoComisiones: (/true/i).test(state.excluidoComisiones),
                requiereValidacionBrief: (/true/i).test(state.requiereValidacionBrief),
                descripcion: state.descripcion.trim(),
                plantillaArticulos: state.plantillaArticulos.trim(),
                parametrosGlobales: (/true/i).test(state.parametrosGlobales),
                pjeGastosFijos: parseFloat(state.pjeGastosFijos),
                pjeInversionFutura: parseFloat(state.pjeInversionFutura),
                pjeImpuestosInternos: parseFloat(state.pjeImpuestosInternos),
                inactivo: state.inactivo,
            }

            let url = 'rubrostrabajos';

            if (state.id != 0) {
                rubroTrabajo.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, rubroTrabajo)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    inactivar ( { }, rubroId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('rubrostrabajos/' + rubroId + '/inactivar')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRubroDatos ( { commit, rootGetters }, rubroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RUBRO_DATOS');

            let userRolId = parseInt(rootGetters['user/rolId']);
            let accesoComisiones = false;
            switch (userRolId) {
              case 1:
              case 2: /* Direccion */
              case 8: /* Calidad */
              case 9: /* Director Ejecutivo */
              case 21: /* Responsable de Finanzas y Proveedores */
                accesoComisiones = true;
                break;
            }

            if (rubroId != 0) {
                apiAxios.get('rubrostrabajos/' + rubroId) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'pjeMargenMinimo', 'campo': 'Pje Margen - Mínimo', 'valor': res.data.pjeMargenMinimo, 'formato': 'numero' },
                            /*{ 'nombre': 'pjeMargenMaximo', 'campo': 'Pje Margen - Máximo', 'valor': res.data.pjeMargenMaximo, 'formato': 'numero' },*/
                            { 'nombre': 'premios', 'campo': 'Premios', 'valor': res.data.premios? 'Si' : 'No', 'formato': '' },
                            { 'nombre': 'reembolsos', 'campo': 'Reembolsos', 'valor': res.data.reembolsos? 'Si' : 'No', 'formato': '' },
                        ]

                        if (accesoComisiones) {
                            datos.push({ 'nombre': 'excluidoComisiones', 'campo': 'Excluido Comisiones', 'valor': res.data.excluidoComisiones? 'Si' : 'No', 'formato': '' });
                        }

                        datos.push({ 'nombre': 'requiereValidacionBrief', 'campo': 'Req. Validación Brief', 'valor': res.data.requiereValidacionBrief? 'Si' : 'No', 'formato': '' });

                        datos.push(
                            { 'nombre': 'descripcion', 'campo': 'Descripción', 'valor': res.data.descripcion, 'formato': '' },
                            { 'nombre': 'plantillaArticulos', 'campo': 'Plantilla - Articulos', 'valor': res.data.plantillaArticulos, 'formato': '' },
                            { 'nombre': 'parametrosGlobales', 'campo': 'Parámetros Globales', 'valor': res.data.parametrosGlobales? 'Si' : 'No', 'formato': '' },
                        )

                        if (!res.data.parametrosGlobales) {
                            datos.push(
                                { 'nombre': 'pjeGastosFijos', 'campo': 'Pje Gastos Fijos', 'valor': res.data.pjeGastosFijos, 'formato': 'numero' },
                                { 'nombre': 'pjeInversionFutura', 'campo': 'Pje Inversión Futura', 'valor': res.data.pjeInversionFutura, 'formato': 'numero' },
                                { 'nombre': 'pjeImpuestosInternos', 'campo': 'Pje Impuestos Internos', 'valor': res.data.pjeImpuestosInternos, 'formato': 'numero' }
                            );
                        }
                        datos.push({ 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' });

                        commit('SET_RUBRO_DATOS', datos);
                        
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}